var cookie = require('react-cookie');
var constants = require('../constants');

var authLogout = (function() {

    var _logOut = function() {
        cookie.remove('mgih_at', {path: '/'});
        cookie.remove('mgih_at_refresh', {path: '/'});
        return {
            type: constants.AUTH_LOGOUT
        };
    }

    return {
        logOut: _logOut
    }
})();

module.exports = authLogout;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-logout.js